import { render, staticRenderFns } from "./TelegramChallenge.vue?vue&type=template&id=1828670d&scoped=true&"
import script from "./TelegramChallenge.vue?vue&type=script&lang=js&"
export * from "./TelegramChallenge.vue?vue&type=script&lang=js&"
import style0 from "./TelegramChallenge.vue?vue&type=style&index=0&id=1828670d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1828670d",
  null
  
)

export default component.exports